export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}company/notification-log`;

    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/NotificationLog/index.js